import AthubCloudApi from "@/api/athubCloud";

export let departments = null;

export async function getDepartments() {
    if (departments == null) {
        departments = await AthubCloudApi.fetchSysDeptAllList();
    }
    console.log(departments);
    return Promise.resolve(departments);
}

export async function getDepartmentsByIds(departmentIds) {
    let result = [];
    if (departmentIds != null && departmentIds.length > 0) {
        departmentIds = departmentIds.map(e => String(e));
        let departments = await getDepartments();
        for (let i = 0, len = departments.length; i < len; i++) {
            if (departmentIds.indexOf(String(departments[i].deptid)) !== -1) {
                result.push(departments[i]);
            }
        }
    }
    return Promise.resolve(result);
}

export async function getDepartmentById(departmentId) {
    let result = null;
    if (departmentId != null) {
        let departments = await getDepartments();
        for (let i = 0, len = departments.length; i < len; i++) {
            if (String(departmentId) === String(departments[i].deptid)) {
                result = departments[i];
                break;
            }
        }
    }
    return Promise.resolve(result);
}

